module.exports = __webpack_public_path__ + "img/black-upload.7d8854ce.svg";